<template>
  <div class="onboarding">
    <!--  Welcome Modal  -->
    <onboarding-modal v-if="welcomeModal" :view="'welcome-modal'">
      <template slot="content">
        <div class="ba-modal-absolute ba-flex ba-f-column ba-ai-center ba-gp-1">
          <img class="absolute modal-banner" src="/internacional/public/office6/img/onboarding/onboarding_modal.svg">

          <span class="title ba-montserrat-700 ba-color-blue19">{{ t['welcome_builderall'] }}</span>
          <span class="subtitle ba-montserrat-500">{{ t['welcome_builderall_congratulations'] }}</span>

          <button class="ba-btn ba-lg ba-blue ba-mg-t-2"
                  @click="showTuorModal()"
          >{{ t['lets_get_started'] }}</button>
        </div>
      </template>
    </onboarding-modal>

    <!--  Tuor Modal  -->
    <onboarding-modal v-if="tuorModal" :view="'tuor-modal'">
      <template slot="content">
        <div class="ba-modal">
          <div class="header ba-flex ba-jc-sb">
            <span class="text ba-color-black6 ba-montserrat-700">{{ t['start_tour'] }}</span>
            <a class="skip ba-color-blue19 ba-montserrat-700">Skip</a>
          </div>
          <div class="ba-hr ba-bg-light1 ba-mg-y-1" />
          <div class="text-center ba-w-100 ba-mg-b-1">
            <spam class="text ba-color-black6 ba-montserrat-700 ">{{ t['start_tour_description'] }}</spam>
          </div>
          <div class="ba-grid card-grid ba-jc-sb">
            <div class="ba-grid-card ba-flex ba-f-column"
                 v-for="(card, i) in modalData"
                 :class="i"
            >
              <span class="ba-card--title ba-montserrat-800 ba-color-dark5" :class="[ card.action != 'start_a_project' ? 'ba-mg-b-1' : '' ]">{{ card.title }}</span>
              <span class="ba-card--description ba-montserrat-500 ba-color-dark5">{{ card.description }}</span>
              <img class="ba-card--img" :src="card.img">
              <button class="ba-btn ba-lg ba-blue modal-select-btn"
                      @click="showHome(card.action)"
              >SELECT</button>
            </div>
          </div>
        </div>
      </template>
    </onboarding-modal>

    <!--  Home  -->
    <onboarding-home v-if="!welcomeModal && !tuorModal" :view="homeData" :show_stepper="true" :stepper_callback="stepperCallback" :current="currentStep" :translation="view.translation"/>
  </div>
</template>

<script>
export default {
  name: 'onboarding-v6',
  props: ['view'],
  data() {
    return {
      welcomeModal: true,
      tuorModal: false,
      modalData: null,
      homeData: null,
      currentStep: '',
      steps: ['community', 'start_a_project', 'training'],
      t: null
    }
  },
  created() {
    this.t = this.view.translation

    this.modalData = [
      { title: this.t['community'], description: this.t['onboarding_modal_community'], img: '/internacional/public/office6/img/onboarding/community.svg', action: 'community' },
      { title: this.t['start_a_project'], description: this.t['onboarding_modal_projects'], img: '/internacional/public/office6/img/onboarding/start-a-project.svg', action: 'start_a_project' },
      { title: this.t['training'], description: this.t['onboarding_modal_training'], img: '/internacional/public/office6/img/onboarding/training.svg', action: 'training' },
    ]
  },
  methods: {
    showTuorModal() {
      this.welcomeModal = false
      this.tuorModal = true
    },
    showHome(action) {
      let index = this.view.onboarding_data.findIndex(x => x.slug == action)

      this.homeData = this.view.onboarding_data[index]
      this.currentStep = action
      this.tuorModal = false
    },
    stepperCallback(data, next, back, current) {
      if (next && !back) {
        let index = this.steps.indexOf(current)+1 > this.steps.length-1 ? this.steps.indexOf(current) : this.steps.indexOf(current)+1,
            nextDataIndex = this.view.onboarding_data.findIndex(x => x.slug == this.steps[index])

        this.homeData = this.view.onboarding_data[nextDataIndex]
        this.currentStep = this.steps[index]
      } else if (!next && back) {
        let index = this.steps.indexOf(current)-1 < 0 ? this.steps.indexOf(current) : this.steps.indexOf(current)-1,
            backDataIndex = this.view.onboarding_data.findIndex(x => x.slug == this.steps[index])

        this.homeData = this.view.onboarding_data[backDataIndex]
        this.currentStep = this.steps[index]
      } else {
        let index = this.view.onboarding_data.findIndex(x => x.slug == data)

        this.homeData = this.view.onboarding_data[index]
        this.currentStep = data
      }
    },
  }
}
</script>

<style scoped lang="scss">
.onboarding {
  position: relative;
}
.ba-modal-absolute {
  position: absolute;
  top: -65px;
  width: 100%;

  .modal-banner {
    width: 595px;
    height: 314px;
  }
  .title {
    font-size: 32px;
    width: auto;
  }
  .subtitle {
    width: 750px;
    text-align: center;
    font-size: 16px;
  }
}
.ba-modal {
  .header {
    .text {
      font-size: 14px;
      letter-spacing: 0.66px;
    }
    .skip {
      font-size: 12px;
    }
  }
}
.ba-hr {
  width: 100%;
  height: 1px;
}
.card-grid {
  grid-template-columns: repeat(3, 254px);
  grid-auto-rows: 412px;

  .ba-grid-card {
    width: 100%;
    height: 100%;
    background: #EBEBEC;
    border-radius: 20px;

    padding: 20px;

    .ba-card--title {
      font-size: 24px;
      font-feature-settings: 'clig' off, 'liga' off;
    }
    .ba-card--description {
      width: 203px;
      height: 84px;
      font-size: 14px;
      line-height: 21px;
      font-feature-settings: 'clig' off, 'liga' off;
    }
    .ba-card--img {
      width: 128px;
      height: 201px;
      margin: 0 auto;
    }
    .modal-select-btn {
      width: 100px;
      margin: 0 auto;
    }
  }
}
</style>

<style lang="scss">
.welcome-modal {
  width: 830px;
  height: 499px;
}
.tuor-modal {
  width: 881px;
  height: 570px;
  padding: 40px;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/onboarding/index.vue